exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-cookie-bar {\n  padding: 0.5em;\n  width: 100%;\n  text-align: center;\n  opacity: 1;\n}\n.uu5-bricks-cookie-bar-top {\n  top: 0;\n  left: 0;\n}\n.uu5-bricks-cookie-bar-bottom {\n  bottom: 0;\n  left: 0;\n}\n.uu5-bricks-cookie-bar-top,\n.uu5-bricks-cookie-bar-bottom {\n  position: fixed;\n  z-index: 110;\n}\n.uu5-bricks-cookie-bar-button {\n  margin: 0 0.5em;\n}\n.uu5-bricks-cookie-bar .uu5-bricks-link {\n  color: inherit;\n}\n.uu5-bricks-cookie-bar.uu5-common-hidden {\n  display: block !important;\n  visibility: hidden;\n  opacity: 0;\n  -webkit-transition: opacity linear 0.5s, visibility linear 0.5s;\n  -moz-transition: opacity linear 0.5s, visibility linear 0.5s;\n  -o-transition: opacity linear 0.5s, visibility linear 0.5s;\n  transition: opacity linear 0.5s, visibility linear 0.5s;\n}\n.uu5-bricks-cookie-bar.uu5-common-disabled {\n  position: fixed !important;\n}\n.uu5-bricks-cookie-bar {\n  background-color: white;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/cookie-bar.less
// module id = 202
// module chunks = 0